import { Thunk } from "common/ReduxUtils";
import log from "Logger";
import { algoliaService } from "../algoliaConfig";

export const clearSearchCache: Thunk = () => async () => {
  log.info({ fn: "clearSearchCache" }, "clearing search cache");
  algoliaService.clearCache();
};
